<template>
  <v-row class="border mt-6">
    <v-col 
      class="px-4"
      cols="6">
      <span 
        class="text-h5 font-weight-medium">
        {{ $t('contract.show.main_panel.headers.payments')}}
      </span>
    </v-col>
    <v-col 
      class="pr-4"
      cols="6">
      <div
        class="d-flex flex-row align-center justify-end"
        style="gap: 8px"
        >
        <v-btn
          color="primary"
          @click="regeneratePayments"
          >
          Regenerar pagos
        </v-btn>

        <v-btn
          @click="$router.push({name: 'CreateTax', id: contract.id})"
          color="primary">
          {{ $t('action.add_tax') }}
        </v-btn>
      </div>
    </v-col>
    <v-col
      cols="12"
      class="pt-0 px-4"
      v-if="contract.currentTaxes.length"
      v-for="tax in contract.currentTaxes"
      >
      <v-card
        class="rounded-lg"
        >
        <v-card-text
          class="text-subtitle-1 black--text py-2 d-flex flex-row justify-space-between align-center"
          >
          <div>
            {{ tax.name }}
            <v-chip
              small
              >{{ period(tax) }}</v-chip>
          </div>
          <div>
            <v-chip
              label
              :class="tax.payments.find(p => p.state == 'pending') ? 'warning--text' : 'success--text'"
              >
              {{ tax.payments.find(p => p.state == 'pending') ? 'Pendiente' : 'Realizado' }}
            </v-chip>

            <v-btn
              icon
              color="primary"
              @click="$router.push('/contract/' + contract.id + '/taxes/edit/' + tax.id)"
              class="ml-3"
              v-if="tax.editable"
              >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        flat
        color="transparent"
        >
        <v-card-text
          class="px-4"
          >
          <template
            v-for="payment in payments(tax)"
            >
            <payment
              :payment="payment"
              ></payment>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { RegeneratePayments } from '@/graphql/mutations/contracts'
import Payment from '@/components/payments/general/Card'

export default {
  name:"MainPanel",
  data(){
    return{
      search: "",
      modal: false,
      selected: null
    }
  },

  props: ['contract'],

  methods: {
    payments (tax) {
      return tax.payments.filter( payment => payment.contractId == this.contract.id )
    },

    showModal (id) {
      this.modal = !this.modal
      this.selected = id
    },

    period (tax) {
      let period

      switch (tax.interval) {
        case 12:
          if (tax.name == 'Alquiler') {
            period = 'Mensual'
          } else {
            period = 'Anual'
          }
          break
        case 6:
          period = 'Semestral'
          break
        case 4:
          period = 'Cuatrimestral'
          break
        case 3:
          period = 'Trimestral'
          break
        case 2:
          period = 'Bimestral'
          break
        case 1:
          period = 'Mensual'
          break
      }

      return period
    },

    regeneratePayments () {
      this.$apollo.mutate({
        mutation: RegeneratePayments,
        variables: {
          input: {
            id: this.contract.id
          }
        }
      }).then( res => {
        this.$emit('reload')
      })
    }
  },

  components: {
    Payment
  }
}
</script>
